const fixedDate = (dateString) => {
    const newDate = new Date(dateString);
    var month = newDate.getUTCMonth() + 1; //months from 1-12
    var day = newDate.getUTCDate();
    var year = newDate.getUTCFullYear();

    return  (day + "." + month + "." + year);
}

module.exports = {fixedDate};